import { Link } from "react-router-dom";
import { linkStyle, handleBlurOnClick } from "./navbarUtils";
import UnderlyingSpan from "./UnderlyingSpan";

const NavbarLink = ({ to, children, className = "", onClick, ...props }) => {
    const handleClick = (e) => {
        handleBlurOnClick(e);
        if (onClick) onClick(e);
    };

    return (
        <Link to={to} className={`${linkStyle} ${className}`} onClick={handleClick} {...props}>
            {children}
            <UnderlyingSpan className="bg-gradient-to-r from-primary to-secondary" />
        </Link>
    );
};

export default NavbarLink;
